import apiRequest from './apiRequest';

// TODO: get actual type for API response
export async function getUserManageSubscription(customerBillingID: string) {
  return apiRequest<{ location: string }>(
    'user',
    `/users/manageSubscription?customerBillingID=${customerBillingID}`,
  );
}
